import { LitElement } from "lit";

// copy document styles into a shared sheet for custom elements
const cache = new Map<string, CSSStyleSheet>();

const sheets = [];
for (const stylesheet of document.querySelectorAll<HTMLLinkElement>(
  'link[rel="stylesheet"]'
)) {
  if (!cache.has(stylesheet.href)) {
    const sheet = new CSSStyleSheet();
    let text = "";
    for (let i = 0; i < stylesheet.sheet.cssRules.length; i++) {
      const rule = stylesheet.sheet.cssRules[i];
      text += rule.cssText;
    }
    sheet.replace(text);
    cache.set(stylesheet.href, sheet);
  }
  sheets.push(cache.get(stylesheet.href));
}

export class BaseElement extends LitElement {
  _display: string;

  connectedCallback(): void {
    super.connectedCallback();
    const display = this.style.display;
    this.style.display = "none";

    this.shadowRoot.adoptedStyleSheets = [
      ...sheets,
      ...this.shadowRoot.adoptedStyleSheets,
    ];
    // safari hax
    requestAnimationFrame(() => {
      this.style.display = display;
    });
  }
}
